import { render, staticRenderFns } from "./AddressEdit.vue?vue&type=template&id=19b543ef&"
import script from "./AddressEdit.vue?vue&type=script&lang=js&"
export * from "./AddressEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports